import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const Plugins = createSvgIcon(
  <>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12891 6.10352e-05H12.9999V7.80006H18.7418V6.10352e-05H24.6128V7.80006H31.9999V14.6751H29.0967V29.7876H20.7418V33.6876H16.8708V40.0001H14.8708V33.6876H10.9999V29.7876H2.9031V14.6751H-0.00012207V7.80006H7.12891V6.10352e-05ZM9.12891 7.80006H10.9999V2.00006H9.12891V7.80006ZM4.9031 14.6751V27.7876H27.0967V14.6751H4.9031ZM12.9999 29.7876V31.6876H18.7418V29.7876H12.9999ZM22.6128 7.80006V2.00006H20.7418V7.80006H22.6128ZM1.99988 9.80006V12.6751H29.9999V9.80006H1.99988Z"
        fill="#06847B"
      />
    </g>
  </>,
  "Plugins"
);

export default Plugins;
